import type { LinkServicesDto } from '@hcr/pwa/api/optimizely'
import type { Link } from '@hcr/pwa/components'

import { EMPTY_PATH_PARAM, Path } from '../../../../models'
import { to } from '../../../navigation'

// TODO 3917: Optimizely: Extend LinkServicesDto with destinationId
//  https://dev.azure.com/HolidayClubResorts/Digital%20Transformation/_workitems/edit/3917
export const createLinkServices = (dto: LinkServicesDto): Link => ({
  label: dto.label,
  to: to([Path.Services, { destinationId: EMPTY_PATH_PARAM }]),
})
